import { DepositsResponseDto, DepositWithRelations } from '@repo/common-types';
import { api } from '@/services/api';

import { GetDepositsDto } from './deposits-types';

export const getDepositsRest = async (params: GetDepositsDto): Promise<DepositsResponseDto> => {
  const { data } = await api.get('v1/admin/deposits', { params });
  return data;
};

export const getDepositByIdRest = async (id: string): Promise<DepositWithRelations> => {
  const { data } = await api.get(`v1/admin/deposits/${id}`);
  return data;
};

export const retryDepositRest = async (id: string): Promise<DepositWithRelations> => {
  const { data } = await api.post(`v1/admin/deposits/${id}/retry`);
  return data;
};
